<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-flex xs12 mb-3>
        <h1 class="max">{{i18n('Usuários')}}</h1>
      </v-flex>
      <v-flex xs12 mb-3>
        <Users />
      </v-flex>
    </v-container>
  </layout>
</template>

<script>

import LeftBarLayout from "../layouts/LeftBarLayout"
import Users from "../components/Users"

export default {
  name: 'UsersPage',
  components: {
    layout: LeftBarLayout,
    Users
  },

  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
  },

  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    let has_registered_company = this.$cookies.isKey('company_id') && this.$cookies.get('company_id') !== ''
    if (!has_registered_company) {
      this.$router.push('/dashboard')
      return
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/UsersPage.vue